/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentMethodInfoFromJSON, PaymentMethodInfoToJSON } from './PaymentMethodInfo';
/**
 * Check if a given object implements the PaymentMethodsResponse interface.
 */
export function instanceOfPaymentMethodsResponse(value) {
    if (!('market' in value) || value['market'] === undefined)
        return false;
    if (!('methods' in value) || value['methods'] === undefined)
        return false;
    return true;
}
export function PaymentMethodsResponseFromJSON(json) {
    return PaymentMethodsResponseFromJSONTyped(json, false);
}
export function PaymentMethodsResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'market': json['market'],
        'methods': (json['methods'].map(PaymentMethodInfoFromJSON)),
    };
}
export function PaymentMethodsResponseToJSON(json) {
    return PaymentMethodsResponseToJSONTyped(json, false);
}
export function PaymentMethodsResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'market': value['market'],
        'methods': (value['methods'].map(PaymentMethodInfoToJSON)),
    };
}
